import DateColumn from './components/DateColumn';
import { FetchColumn } from './components/FetchColumn';
import genderColumn from './components/GenderColumn';
import IndexColumn from './components/IndexColumn';
import InstitutionColumn from './components/InstitutionColumn';
import StatusColumn from './components/StatusColumn';
import ElapsedTimeColumn from './components/ElapsedTimeColumn';
import creatorColumn from './components/creatorColumn';
import WaitingTimeColumn from './components/WaitingTimeColumn';
import WaitingTimeColumnWithPriority from './components/WaitingTimeColumnWithPriority';

interface SubComponents {
  Index: typeof IndexColumn;
  Creator: typeof creatorColumn;
  Date: typeof DateColumn;
  Institution: typeof InstitutionColumn;
  Status: typeof StatusColumn;
  Gender: typeof genderColumn;
  Fetch: typeof FetchColumn;
  ElapsedTime: typeof ElapsedTimeColumn;
  WaitingTime: typeof WaitingTimeColumn;
  WaitingTimeWithPriority: typeof WaitingTimeColumnWithPriority;
}

type ColumnTemplateType = React.FC<{
  children: React.ReactNode;
}> &
  SubComponents;

const ColumnTemplate: ColumnTemplateType = ({ children }: { children: React.ReactNode }) => {
  return <div className="my-3 flex flex-wrap gap-1 text-[12px]">{children}</div>;
};

ColumnTemplate.Index = IndexColumn;
ColumnTemplate.Creator = creatorColumn;
ColumnTemplate.Date = DateColumn;
ColumnTemplate.Institution = InstitutionColumn;
ColumnTemplate.Status = StatusColumn;
ColumnTemplate.Gender = genderColumn;
ColumnTemplate.Fetch = FetchColumn;
ColumnTemplate.ElapsedTime = ElapsedTimeColumn;
ColumnTemplate.WaitingTime = WaitingTimeColumn;
ColumnTemplate.WaitingTimeWithPriority = WaitingTimeColumnWithPriority;

ColumnTemplate.displayName = 'ColumnTemplate';
export default ColumnTemplate;
